import { render, staticRenderFns } from "./QuickReplies.vue?vue&type=template&id=7ed20ace&scoped=true&"
import script from "./QuickReplies.vue?vue&type=script&lang=js&"
export * from "./QuickReplies.vue?vue&type=script&lang=js&"
import style0 from "./QuickReplies.vue?vue&type=style&index=0&id=7ed20ace&prod&lang=scss&scoped=true&"
import style1 from "./QuickReplies.vue?vue&type=style&index=1&id=7ed20ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed20ace",
  null
  
)

export default component.exports